/** Normalize plate text for UI: trim and uppercase (e.g. `aa1` → `AA1`). */
export function formatPlateForDisplay(plate: string | null | undefined): string {
  return (plate ?? "").trim().toUpperCase();
}
